import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./css/liquidityhub.css";

export default function Liquidityhub() {
  const navigate = useNavigate();
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);

  const infiApplicationForm = () => {
    navigate(`${config.baseUrl}infiListingForm`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="infiLaunchpad position-relative pt-5 pb-0 overflow-hidden">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center">
            <Col lg={12}>
              <div className="">
                <Card className=" bg-transparent border-0">
                  <Card.Body>
                    <div className=" position-relative mb-5">
                      <Row className="justify-content-center">
                        <Col lg={12}>
                          <div className="position-relative d-inline-block text-left">
                            <h1 className=" position-relative text-white lh-sm mb-5">
                              <span className="position-relative z-1">
                                SbSe Liquidity HUB
                                <span className="fw-normal">
                                  &nbsp;– Seamless & Decentralized
                                  Swap Aggregator, Powered by the SbSe Protocol
                                </span>
                              </span>
                              <div
                                className="polygon"
                                style={{ right: "0px" }}
                              >
                                <img
                                  src="images/shape/polygon3.png"
                                  alt=""
                                  style={{ width: "208px" }}
                                />
                              </div>
                            </h1>
                          </div>
                        </Col>
                      </Row>

                      <div className="">
                        <Row>
                          <Col lg={6} className="mb-4">
                            <div className="cardStyle1">
                              <Card className="p-4 cardBox1">
                                <div class="d-flex align-items-center">
                                  <div class="me-3">
                                    <img
                                      src="images/icon/getstarted.svg"
                                      class="infi-icon mb-0"
                                      alt=""
                                    />
                                  </div>
                                  <div>
                                    <h5 className="text-white">
                                      Instant Swap Aggregator
                                    </h5>
                                    <p class="text-light-grey2 mb-0">
                                      Access decentralized cross-chain token swap aggregator, OTC
                                      functionality, and autonomous trade execution — all operated by
                                      permissionless smart contracts.
                                    </p>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          </Col>
                          <Col lg={6} className="mb-4">
                            <div className="cardStyle1">
                              <Card className="p-4 cardBox1">
                                <div class="d-flex align-items-center">
                                  <div class="me-3">
                                    <img
                                      src="images/icon/getstarted.svg"
                                      class="infi-icon mb-0"
                                      alt=""
                                    />
                                  </div>
                                  <div>
                                    <h5 className="text-white">
                                      Fully Protocol-Governed
                                    </h5>
                                    <p class="text-light-grey2 mb-0">
                                      Trade execution, pricing logic, and asset routing are managed
                                      entirely by the SbSe Protocol — without human intervention or
                                      centralized control.
                                    </p>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          </Col>
                          <Col lg={6} className="mb-4">
                            <div className="cardStyle1">
                              <Card className="p-4 cardBox1">
                                <div class="d-flex align-items-center">
                                  <div class="me-3">
                                    <img
                                      src="images/icon/getstarted.svg"
                                      class="infi-icon mb-0"
                                      alt=""
                                    />
                                  </div>
                                  <div>
                                    <h5 className="text-white">Protocol-Based Incentives</h5>
                                    <p class="text-light-grey2 mb-0">
                                      Eligible users may access variable protocol incentives (e.g. DAI
                                      or INFI) based on ecosystem activity and smart contract
                                      conditions. No fixed rewards or financial guarantees are offered.
                                    </p>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          </Col>
                          <Col lg={6} className="mb-4">
                            <div className="cardStyle1">
                              <Card className="p-4 cardBox1">
                                <div class="d-flex align-items-center">
                                  <div class="me-3">
                                    <img
                                      src="images/icon/getstarted.svg"
                                      class="infi-icon mb-0"
                                      alt=""
                                    />
                                  </div>
                                  <div>
                                    <h5 className="text-white">
                                      Transparent & Autonomous Security
                                    </h5>
                                    <p class="text-light-grey2 mb-0">
                                      All activity is protected through real-time on-chain mechanisms,
                                      including the SbSe Reserve and monitoring integrations like
                                      Cyvers — ensuring decentralized transparency without custodial
                                      risks.
                                    </p>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <div className="text-center">
                              <Button
                                variant="white-gradient"
                                className="me-sm-3 px-5 rounded-5"
                              >
                                <div className="d-flex gap-2 align-items-center">
                                  <div className="lh-1">
                                    SBSE OTC ORDER-BOOK
                                    <div className="text-success text-uppercase x-small">
                                      (Coming soon)
                                    </div>
                                  </div>
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="16"
                                      viewBox="0 0 24 19"
                                      fill="none"
                                    >
                                      <path
                                        d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                        stroke="black"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </Button>
                              <Button
                                variant="default"
                                className="border px-5 rounded-5 text-white fw-normal"
                              >
                                <div className="d-flex gap-2 align-items-center">
                                  <div className="lh-1">
                                    INSTANT SWAPS
                                    <div className="text-success text-uppercase x-small">
                                      (Coming soon)
                                    </div>
                                  </div>
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="16"
                                      viewBox="0 0 24 19"
                                      fill="none"
                                    >
                                      <path
                                        d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
